import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();

    // Send to your backend API
    fetch('YOUR_BACKEND_API_URL/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: name,
        email: email,
        message: message,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        alert('Message sent successfully! We will contact you soon.');
        clearState();
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Failed to send message. Please try again.');
      });
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2 style={{ color: '#000'}}>Get Free Gold Evaluation - Contact AHVI Gold</h2>
                <p style={{ marginLeft: 4}}>
                  Ready to sell your gold at the best price? Fill out the form below and our certified gold appraisers will contact you with a free evaluation and the best market quote for your gold items.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Describe your gold items (type, weight, karat, etc.)"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg" style={{ color: '#000' , background:'#000'}}>
                  Request Quote
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3 style={{ color: '#000'}}>Contact Info</h3>
              <p>
                <span style={{ color: '#000'}}>
                  <i className="fa fa-map-marker" ></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span style={{ color: '#000'}}>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
              <p>
                <span style={{ color: '#000'}}>
                  <i className="fa fa-phone"></i> Alt. Phone
                </span>{" "}
                {props.data ? props.data.phone2 : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span style={{ color: '#000'}}>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span style={{ color: '#000'}}>
                  <i className="fa fa-clock-o"></i> Working Hours
                </span>{" "}
                Mon - Sat: 10:00 AM - 7:00 PM
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social" style={{ marginTop: '20px' }}>
                <ul style={{ listStyle: 'none', padding: 0, display: 'flex', justifyContent: 'center', gap: '20px' }}>
                  <li>
                    <a href="https://www.facebook.com/people/Ahvi-Gold-Pvt-Ltd/61583858002945/" target="_blank" rel="noopener noreferrer" title="Follow us on Facebook">
                      <i className="fa fa-facebook" style={{ fontSize: '24px', color: '#1877F2' }}></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/ahvi_gold/" target="_blank" rel="noopener noreferrer" title="Follow us on Instagram">
                      <i className="fa fa-instagram" style={{ fontSize: '24px', color: '#E4405F' }}></i>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+916001488285" title="Call us">
                      <i className="fa fa-phone" style={{ fontSize: '24px', color: '#25D366' }}></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 AHVI Gold - Your Trusted Gold Buyers. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
